import { gql, useQuery } from '@apollo/client'

import { RemoteParamKeys, useToggle } from '@/lib/firebase/hooks'

// Apollo query to check if the search results page URL contains the query parameter search=true.
const SEARCH_CLIENT_QUERY = gql`
  query SearchClientData {
    searchClient {
      isDomCat
      searchValue
    }
  }
`
/**
 * This hook is being used to determine if we should show the new design of the mweb SRP developed in KJCA-4733
 * Due to the SEO version of the SRP, we only want this toggle to return true if it is enabled
 * and we have "search=true" in the URL
 * For more info please refer to: https://jira.ets.mpi-internal.com/browse/KJCA-4733
 */
export const useSrpMwebRedesign = (isSearchResultsPage: boolean) => {
  const isSrpControlsMwebToggleEnabled =
    useToggle(RemoteParamKeys.SRP_CONTROLS_MWEB_REDESIGN)?.enabled ?? false
  const { data: searchClientData } = useQuery(SEARCH_CLIENT_QUERY, {
    fetchPolicy: 'cache-only',
    skip: !isSearchResultsPage,
  })
  const isSearchTrue = searchClientData?.searchClient?.searchValue === true
  const isDomCat = searchClientData?.searchClient?.isDomCat === true
  return isSrpControlsMwebToggleEnabled && (isSearchTrue || isDomCat)
}
